import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiCall } from "../service/api";

const AuthContext = createContext();

export const ADMIN_ROLE = "billing-admin"
export const ORG_MANAGER_ROLE = "billing-manager"
export const SIMPLE_USER_ROLE = "billing-simple-user"





export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(localStorage.getItem('user') || null);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const [role, setRole] = useState(() => {
    const savedRole = localStorage.getItem('role');
    if (!savedRole) {
      return [];
    }

    try {
      const parsedRole = JSON.parse(savedRole);
      return Array.isArray(parsedRole) ? parsedRole : [parsedRole];
    } catch {
      return [];
    }
  });


  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    const savedToken = localStorage.getItem('token');
    const savedRole = localStorage.getItem('role');

    setUser(savedUser || null);
    setToken(savedToken || null);
    setIsLoggedIn(!!savedToken);
    if (savedRole) {
      try {
        const parsedRole = JSON.parse(savedRole);
        setRole(Array.isArray(parsedRole) ? parsedRole : [parsedRole]);
      } catch {
        setRole([]);
      }
    } else {
      setRole([]);
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    const route = '/login/';
    const method = 'POST';
    const data = { username, password };

    try {
      const response = await apiCall(route, method, data);
      if (response) {
        // setUser(response);
        setIsLoggedIn(true);
        setUser(username);
        setToken(response.token);
        const normalizedRole = Array.isArray(response.role)
          ? response.role
          : response.role
            ? [response.role]
            : [];
        setRole(normalizedRole);
        localStorage.setItem('user', username);
        localStorage.setItem('token', response.token);
        localStorage.setItem('role', JSON.stringify(normalizedRole));
      }
      return true;
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
  }, [token]);
  const logout = () => {
    setIsLoggedIn(false);
    setUser(null);
    setToken(null);
    setRole([]);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
  };

  const hasRole = (targetRole) => {
    if (!targetRole || role.length === 0) {
      return false;
    }
    return role.includes(targetRole);
  }

  const getRole = () => {
    return role;
  }
  return (
    <AuthContext.Provider value={{
      user,
      isLoggedIn,
      token,
      isLoading,
      error,
      role,
      login,
      logout,
      hasRole,
      getRole,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
